import { RG_TYPE } from "@project-rouge/rg-core";
import { getRgObjectsOfType as getRgObjectsOfType$1 } from "@project-rouge/rg-three";
const getActiveZones = (parent, aggProps) => {
	return getRgObjectsOfType$1(parent, RG_TYPE.Zone).filter((zone) => zone.uuid in aggProps.zones);
};
export { getActiveZones };

//# sourceMappingURL=index23.js.map